import * as THREE from 'three';

/** Dispose GPU-backed resources reachable from a scene graph before releasing its renderer. */
export function disposeSceneResources(target: THREE.Object3D | null): void {
  if (!target) return;
  target.traverse((object) => {
    const resource = object as THREE.Object3D & {
      geometry?: THREE.BufferGeometry;
      material?: THREE.Material | THREE.Material[];
    };
    resource.geometry?.dispose();
    const materials = resource.material
      ? Array.isArray(resource.material) ? resource.material : [resource.material]
      : [];
    for (const material of materials) {
      for (const value of Object.values(material)) {
        if (value && typeof value === 'object' && 'isTexture' in value && value.isTexture) {
          (value as THREE.Texture).dispose();
        }
      }
      material.dispose();
    }
  });
}
